module.exports = __webpack_public_path__ + "img/indian.65b9f4e5.webp";